import React from 'react'
import {Link} from 'react-router-dom'

export default props => <nav className="navbar is-fixed-top is-dark" role="navigation" aria-label="main navigation" style={{
  zIndex: 100000
}}>
  <div className="navbar-brand">
  <Link className="navbar-item" to="/" className='titlefont' style={{
    fontSize: '35px',
    color: 'white',
    padding: '0 10px 0 20px',
  }}>
      Arteco
    </Link>


  </div>

  <div id="navbarBasicExample" className="navbar-menu">
    <div className="navbar-start">
      <Link to='/omnie' className="navbar-item">
        O mnie
      </Link>
      <Link to='/galeria' className="navbar-item">
        Zdjęcia
      </Link>
      <Link to='/quizy' className="navbar-item">
        Quizy
      </Link>
      <Link to='/kontakt' className="navbar-item">
        Kontakt
      </Link>
    </div>
  </div>
</nav>



// WEBPACK FOOTER //
// ./src/Navbar.js